'use client'

import AppContext from "AppContext";
import CustomDropzone from "components/CustomDropzone";
import GeneralForm from "components/GeneralForm";
import TitleFormWithEdit from "components/TitleFormWithEdit";
import { validate } from "components/validateGeneralForm";
import { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Card, CardBody, Container, FormGroup, Input, Label } from "reactstrap";
import arquivoService from "services/ArquivoService";
import projetoService from "services/ProjetoService";
import { erroInesperado } from "services/Utils";

export default function FormProjeto() {
  const [data, setData] = useState({})
  const [edit, setEdit] = useState(false)
  const [arquivo, setArquivo] = useState(null)
  const [arquivoPdf, setArquivoPdf] = useState(null)
  const { state } = useContext(AppContext)
  const params = useParams()
  const navigate = useNavigate()

  const id = parseInt(params.id)
  // const novo = (0 === id)

  const podeEditar = (state?.user?.acoes || []).includes('projeto.gerenciar')

  useEffect(() => {
    if (!!id) {
      projetoService.getById(id).then(res => {
        if (res.success) {
          setData(res.data)
        }
      })
    } else {
      navigate(-1)
    }
  }, [id])

  // useEffect(() => {
  //   if (novo) {
  //     setEdit(true)
  //   }
  // }, [novo])

  const handleChangeArquivo = (value) => {
    if (!value) {
      setData({ ...data, arquivo: null })
    }
    setArquivo(value)
  }

  const handleChangeArquivoPdf = (value) => {
    if (!value) {
      setData({ ...data, arquivoPdf: null })
    }
    setArquivoPdf(value)
  }

  const formConfig = useMemo(() => {
    return [
      [
        { name: "numeroOSFmt", label: 'Número OS', type: "text", disabled: true, colspan: 6 },
        { name: "numenc", label: 'Numenc', type: "text", required: true, colspan: 6 },
        { name: "titulo", label: 'Título', type: "text", required: true, colspan: 12 },
        {
          name: "arquivo",
          type: "view",
          required: true,
          colspan: 6,
          component: () => {
            if (arquivo || data.arquivo) {
              const nomeArquivo = arquivo ? arquivo.name : data.arquivo.nomeArquivo
              const funcaoExcluir = arquivo ? () => handleChangeArquivo(null) : () => handleChange('arquivo', null)
              return (
                <>
                  <FormGroup>
                    <Label>Arquivo DWG</Label>
                    <Input type="text" value={nomeArquivo} disabled={true} />
                  </FormGroup>
                  <div className="d-flex">
                    {edit && (
                      <Button color="danger" outline onClick={funcaoExcluir} className="mr-2">
                        Excluir
                      </Button>
                    )}
                    {data.arquivo?.mostrarDownload && (
                      <a className="btn btn-outline-primary" href={`${process.env.REACT_APP_API_URL}arquivo/${data.arquivo.id}/download`}>Download</a>
                    )}
                  </div>
                </>
              )
            }
            return (
              <>
                <div>Arquivo DWG</div>
                <CustomDropzone
                  onChange={value => handleChangeArquivo(value)}
                  onRemove={() => handleChangeArquivo(null)}
                  edit={edit}
                />
              </>
            )
          }
        },
        {
          name: "arquivoPdf",
          type: "view",
          colspan: 6,
          component: () => {
            if (arquivoPdf || data.arquivoPdf) {
              const nomeArquivo = arquivoPdf ? arquivoPdf.name : data.arquivoPdf.nomeArquivo
              const funcaoExcluir = arquivoPdf ? () => handleChangeArquivoPdf(null) : () => handleChange('arquivoPdf', null)
              return (
                <>
                  <FormGroup>
                    <Label>Arquivo PDF</Label>
                    <Input type="text" value={nomeArquivo} disabled={true} />
                  </FormGroup>
                  <div className="d-flex">
                    {edit && (
                      <Button color="danger" outline onClick={funcaoExcluir} className="mr-2">
                        Excluir
                      </Button>
                    )}
                    {data.arquivoPdf?.mostrarDownload && (
                      <a className="btn btn-outline-primary" href={`${process.env.REACT_APP_API_URL}arquivo/${data.arquivoPdf.id}/download`}>Download</a>
                    )}
                  </div>
                </>
              )
            }
            return (
              <>
                <div>Arquivo PDF</div>
                <CustomDropzone
                  onChange={value => handleChangeArquivoPdf(value)}
                  onRemove={() => handleChangeArquivoPdf(null)}
                  edit={edit}
                  accept=".pdf,application/pdf"
                />
              </>
            )
          }
        },
      ]
    ]
  }, [data.arquivo, arquivo, data.arquivoPdf, arquivoPdf, edit])

  const handleChange = (name, value) => {
    setData({ ...data, [name]: value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const errors = validate(formConfig, data)
    if (errors.length > 0) {
      setData({ ...data, errors })
      return
    }

    try {
      if (arquivo) {
        const res = await arquivoService.upload(arquivo)
        if (res.success) {
          data.arquivo = { id: res.data }
        } else {
          toast('Erro ao enviar arquivo')
          return
        }
      }

      if (arquivoPdf) {
        const res = await arquivoService.upload(arquivoPdf)
        if (res.success) {
          data.arquivoPdf = { id: res.data }
        } else {
          toast('Erro ao enviar arquivo')
          return
        }
      }

      await projetoService.update(id, data)
      toast('Registro salvo com sucesso!')
      navigate('/admin/projetos')
    } catch (ex) {
      erroInesperado()
    }

  }

  return (
    <Container fluid>
      <TitleFormWithEdit title="Projetos" edit={edit} onChangeEdit={setEdit} showButton={podeEditar} />
      <Card>
        <CardBody>
          <form onSubmit={handleSubmit}>
            <GeneralForm
              config={formConfig}
              data={data}
              onChange={handleChange}
              disabled={!edit}
            />
            {edit && (
              <Button type="submit" color="primary" className="mt-2">Salvar</Button>
            )}
          </form>
        </CardBody>
      </Card>
    </Container>
  )
}